import Cookies from 'js-cookie';
import { getCookieDomain } from './cookieDomain';

export interface CouponCookieData {
  code: string;
  bannerText?: string;
  /** GWA entrypoint attribution (e.g. `fi_nano_registration`), forwarded into the purchase. */
  source?: string;
  /** Originating rescue's GWA program id, forwarded into the purchase for redemption attribution. */
  rescueGwaProgramId?: number;
}

export function removeCookie(name: string) {
  Cookies.remove(name, { domain: getCookieDomain() });
}

export const COUPON_COOKIE_NAME = 'coupon_data';
export const COUPON_COOKIE_EXPIRATION_HOURS = 72;

/**
 * Separate cookie holding the signed GWA entitlement (program-id context) from the offer-token
 * exchange or the rescue slug landing. Kept out of `coupon_data` so the coupon-apply machinery can't
 * clobber it (the slug flow has no code to apply), and forwarded on pricing/validate/purchase.
 */
export const GWA_ENTITLEMENT_COOKIE_NAME = 'gwa_entitlement';
